import {createRouter, createWebHistory} from 'vue-router';
import modules from '@/router/modules';
import {ROUTE_NAMES_AUTH} from "@/router/modules/auth";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: modules
});

router.beforeEach(async (to, from, next) => {

  if (to.matched.length === 0 ) {
    next({ name: ROUTE_NAMES_AUTH.LOGIN });
    return
  }
  for (const route of to.matched) {
    if (route.meta && route.meta.guard) {
      /** Let each guard handle route access **/
      const result = await route.meta.guard.handleRouteEnter();
      if (result !== true) {
        next({name: result});
        return
      }
    }
  }
  next()
});

export default router;
